export const addResizeListener = (currentClass, heightKey = 'height', widthKey = 'width') => {
  updateWindowDimensions(currentClass, heightKey, widthKey);
  window.addEventListener('resize', () =>
    updateWindowDimensions(currentClass, heightKey, widthKey)
  );
};

export const removeResizeListener = () => {
  window.removeEventListener('resize', updateWindowDimensions);
};

const updateWindowDimensions = (currentClass, heightKey, widthKey) => {
  currentClass.setState({ [widthKey]: window.innerWidth, [heightKey]: window.innerHeight });
};
